import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['postButton', 'postToggle', 'postBody', 'submitButton']

  postToggle() {
    if(this.postBodyTarget.classList.contains('d-none')){
      this.postBodyTarget.classList.remove('d-none');
      this.submitButtonTarget.innerHTML = 'Subscribe and Post';
    } else {
      this.postBodyTarget.classList.add('d-none');
      this.submitButtonTarget.innerHTML = 'Subscribe';
    }
  }

}
